import { Component, Input, OnInit } from '@angular/core';
import { UserService } from 'src/app/assabil-kernel/services/user-service';


@Component({
  selector: 'assabil-admin-menu',
  templateUrl: './assabil-admin-menu.component.html',
  styleUrls: ['./assabil-admin-menu.component.scss']
})
export class AssabilAdminMenuComponent implements OnInit {

  @Input() shrinkMode : boolean = false;
  
  constructor(
    public userService         : UserService,
  ) { }

  ngOnInit() {
  }


// masterData = {
            //   'id'          : 'master-data',
            //   'title'       : 'Master Data',
            //   'prefix'      : "D",
            //   'blocs'  :  [
            //                     {
            //                       'id'         : 'master-data-partner',
            //                       'title'      : 'Partenaires',
            //                       'icon'       :  'assets/images/icons/mobile-app.png',
            //                       'items'      : [
            //                                         {
            //                                             'id'        : 'master-data-partner-partner',
            //                                             'label'     : 'Partenaires',
            //                                             'icon'      : "assets/icons/invoice.png",
            //                                             'route'     : './sales/partners'
            //                                       },
            //                                         {
            //                                             'id'        : 'master-data-partner-itinerary',   
            //                                             'label'     : 'itinéraires',
            //                                             'icon'      : "assets/icons/invoice.png",
            //                                             'route'     : './sales/itineraries',
            //                                       },
            //                                         {
            //                                             'id'        : 'master-data-partner-site',   
            //                                             'label'     : 'Sites',
            //                                             'icon'      : "assets/icons/invoice.png",
            //                                             'route'     : './sales/partners-sites'
            //                                       },
            //                                         {
            //                                             'id'        : 'master-data-partner-pricelist',   
            //                                             'label'     : 'Liste de Prix',
            //                                             'icon'      : "assets/icons/invoice.png",
            //                                             'route'     : './sales/priceLists',
            //                                       }
            //                                     ]
            //                     },

            //                     {
            //                       'id'         : 'master-data-product',
            //                       'title'      : 'Produits',
            //                       'icon'       :  'assets/images/icons/mobile-app.png',
            //                       'items'      : [
            //                                         {
            //                                             'id'        : 'master-data-product-product',   
            //                                             'label'     : "Produits",
            //                                             'icon'      : "assets/icons/invoice.png",
            //                                             'route'     : './sales/products'
            //                                         },
            //                                         {
            //                                             'id'        : 'master-data-product-brand',
            //                                             'label'     : "Marques",
            //                                             'icon'      : "assets/icons/invoice.png",
            //                                             'route'     : './sales/brand'
            //                                         }
            //                                       ]
            //                     },

            //                     {
            //                       'id'         : 'master-data-person',
            //                       'title'      : 'Personnes',
            //                       'icon'       :  'assets/images/icons/mobile-app.png',
            //                       'items'      : [
            //                                         {
            //                                             'id'        : 'master-data-person-person', 
            //                                             'label'     : "Personnes",
            //                                             'icon'      : "assets/icons/invoice.png",
            //                                             'route'     : './sales/person'
            //                                         },
            //                                         {
            //                                             'id'        : 'master-data-person-role',
            //                                             'label'     : "Roles",
            //                                             'icon'      : "assets/icons/invoice.png",
            //                                             'route'     : './sales/role'
            //                                         },
            //                                         {
            //                                             'id'        : 'master-data-profile',
            //                                             'label'     : "Profiles",
            //                                             'icon'      : "assets/icons/invoice.png",
            //                                             'route'     : './sales/profile'
            //                                         }    
            //                                     ]
            //                     },
            //                   ]
            //   };


// controlTables = {
            //     'id'          : 'master-data-control',
            //     'title'       : 'Tables de contrôle',
            //     'prefix'      : "C",
            //     'blocs'  : [
            //                       {
            //                         'id'         : 'master-data-control-partner',
            //                         'title'      : 'Partenaires',
            //                         'icon'       :  'assets/images/icons/mobile-app.png',
            //                         'items'      : [
            //                                           {
            //                                             'id'        : 'master-data-control-partner',   
            //                                             'label'     : "Categories",
            //                                             'icon'      : "assets/icons/invoice.png",
            //                                             'route'     : './sales/partnerCategory'
            //                                         },
            //                                         {
            //                                           'id'        : 'master-data-control-partner',   
            //                                           'label'     : "Analysis Group1",
            //                                           'icon'      : "assets/icons/invoice.png",
            //                                           'route'     : './sales/partnerAnalysisGroup1'
            //                                     },
            //                                       { 
            //                                           'id'        : 'master-data-control-partner',    
            //                                           'label'     : "Analysis Group2",
            //                                           'icon'      : "assets/icons/invoice.png",
            //                                           'route'     : './sales/partnerAnalysisGroup2'
            //                                     },
            //                                       {
            //                                           'id'        : 'master-data-control-partner',    
            //                                           'label'     : "Analysis Group3",
            //                                           'icon'      : "assets/icons/invoice.png",
            //                                           'route'     : './sales/partnerAnalysisGroup3'
            //                                     },
            //                                       {
            //                                           'id'        : 'master-data-control-partner',    
            //                                           'label'     : "Analysis Group4",
            //                                           'icon'      : "assets/icons/invoice.png",
            //                                           'route'     : './sales/partnerAnalysisGroup4'
            //                                     },
            //                                       {
            //                                           'id'        : 'master-data-control-partner',    
            //                                           'label'     : "Analysis Group5",
            //                                           'icon'      : "assets/icons/invoice.png",
            //                                           'route'     : './sales/partnerAnalysisGroup5'
            //                                     },
            //                                       {
            //                                           'id'        : 'master-data-control-partner',    
            //                                           'label'     : "Banks",
            //                                           'icon'      : "assets/icons/invoice.png",
            //                                           'route'     : './sales/banks'
            //                                     },
            //                                       {
            //                                           'id'        : 'master-data-control-partner', 
            //                                           'label'     : "Types d'itinéraires",
            //                                           'icon'      : "assets/icons/invoice.png",
            //                                           'route'     : './sales/itineraryTypes'
            //                                     }

            //                                       ]
            //                       },

            //                       {
            //                         'id'         : 'master-data-control-product',
            //                         'title'      : 'Produits',
            //                         'icon'       :  'assets/images/icons/mobile-app.png',
            //                         'items'      : [
            //                                         {
            //                                             'id'        : 'master-data-control-product',  
            //                                             'label'     : "Categories",
            //                                             'icon'      : "assets/icons/invoice.png",
            //                                             'route'     : './sales/productCategory'
            //                                         },
            //                                         {
            //                                               'id'        : 'master-data-control-product', 
            //                                               'label'     : "Analysis Group1",
            //                                               'icon'      : "assets/icons/invoice.png",
            //                                               'route'     : './sales/productAnalysisGroup1'
            //                                         },
            //                                         { 
            //                                               'id'        : 'master-data-control-product',
            //                                               'label'     : "Analysis Group2",
            //                                               'icon'      : "assets/icons/invoice.png",
            //                                               'route'     : './sales/productAnalysisGroup2'
            //                                         },
            //                                         {
            //                                               'id'        : 'master-data-control-product',  
            //                                               'label'     : "Analysis Group3",
            //                                               'icon'      : "assets/icons/invoice.png",
            //                                               'route'     : './sales/productAnalysisGroup3'
            //                                         },
            //                                         {
            //                                               'id'        : 'master-data-control-product',  
            //                                               'label'     : "Analysis Group4",
            //                                               'icon'      : "assets/icons/invoice.png",
            //                                               'route'     : './sales/productAnalysisGroup4'
            //                                         },
            //                                         {
            //                                               'id'        : 'master-data-control-product',  
            //                                               'label'     : "Analysis Group5",
            //                                               'icon'      : "assets/icons/invoice.png",
            //                                               'route'     : './sales/productAnalysisGroup5'
            //                                         },
            //                                         {
            //                                               'id'        : 'master-data-control-product',  
            //                                               'label'     : "Atributs",
            //                                               'icon'      : "assets/icons/invoice.png",
            //                                               'route'     : './sales/productAttributes'
            //                                         },
            //                                         {
            //                                               'id'        : 'master-data-control-product',  
            //                                               'label'     : "Groupe logistique",
            //                                               'icon'      : "assets/icons/invoice.png",
            //                                               'route'     : './sales/productLogisticGroups'
            //                                         },
            //                                           {
            //                                               'id'        : 'master-data-control-product',  
            //                                               'label'     : "Page",
            //                                               'icon'      : "assets/icons/invoice.png",
            //                                               'route'     : './sales/productPage'
            //                                         },
            //                                         {
            //                                               'id'        : 'master-data-control-product',   
            //                                               'label'     : "Groupe de ventes",
            //                                               'icon'      : "assets/icons/invoice.png",
            //                                               'route'     : './sales/productSalesGroup'
            //                                         },
            //                                         {
            //                                               'id'        : 'master-data-control-product', 
            //                                               'label'     : "Groupes d'atributs",
            //                                               'icon'      : "assets/icons/invoice.png",
            //                                               'route'     : './sales/productAttributeGroup'
            //                                         }

            //                                     ]
            //                       },

            //                       {
            //                         'id'         : 'master-data-partner',
            //                         'title'      : 'Autres',
            //                         'icon'       :  'assets/images/icons/mobile-app.png',
            //                         'items'      : [
            //                                         {
            //                                             'id'        : 'master-data-team',  
            //                                             'label'     : "Agences",
            //                                             'icon'      : "assets/icons/invoice.png",
            //                                             'route'     : './sales/branch'
            //                                         },
            //                                         {
            //                                           'id'        : 'master-data-team',  
            //                                           'label'     : "Types Région Géo.",
            //                                           'icon'      : "assets/icons/invoice.png",
            //                                           'route'     : './sales/geoAreaType'
            //                                         },
            //                                         {
            //                                           'id'        : 'master-data-team',  
            //                                           'label'     : "Régions Géographiques",
            //                                           'icon'      : "assets/icons/invoice.png",
            //                                           'route'     : './sales/geoArea'
            //                                         },
            //                                         {
            //                                             'id'        : 'master-data-team',  
            //                                             'label'     : "Raisons d'annulation",
            //                                             'icon'      : "assets/icons/invoice.png",
            //                                             'route'     : './sales/cancelationReason'
            //                                         },
            //                                         {
            //                                             'id'        : 'master-data-team',  
            //                                             'label'     : "Raisons de Transfert",
            //                                             'icon'      : "assets/icons/invoice.png",
            //                                             'route'     : './sales/warehouseTransferReason'
            //                                         },
            //                                         {
            //                                               'id'        : 'master-data-team',  
            //                                               'label'     : "Visit Result",
            //                                               'icon'      : "assets/icons/invoice.png",
            //                                               'route'     : './sales/visitResult',
            //                                         },
            //                                           {
            //                                               'id'        : 'master-data-team',  
            //                                               'label'     : "VAT",
            //                                               'icon'      : "assets/icons/invoice.png",
            //                                               'route'     : './sales/VAT',
            //                                         },
            //                                           {
            //                                               'id'        : 'master-data-team',  
            //                                               'label'     : "Monnaie",
            //                                               'icon'      : "assets/icons/invoice.png",
            //                                               'route'     : './sales/currency'
            //                                         },
            //                                           {
            //                                               'id'        : 'master-data-team',  
            //                                               'label'     : "Coupures de banque",
            //                                               'icon'      : "assets/icons/invoice.png",
            //                                               'route'     : './sales/bankNotes'
            //                                         },
            //                                           {
            //                                               'id'        : 'master-data-team',  
            //                                               'label'     : "Langues",
            //                                               'icon'      : "assets/icons/invoice.png",
            //                                               'route'     : './sales/language'
            //                                         },
            //                                           {
            //                                               'id'        : 'master-data-team',  
            //                                               'label'     : "Modalité de paiement",
            //                                               'icon'      : "assets/icons/invoice.png",
            //                                               'route'     : './sales/paymentTerm',
            //                                         },
            //                                           {
            //                                               'id'        : 'master-data-team',  
            //                                               'label'     : "Canaux de ventes",
            //                                               'icon'      : "assets/icons/invoice.png",
            //                                               'route'     : './sales/salesChannels',
            //                                         },
            //                                         {
            //                                               'id'        : 'master-data-team',  
            //                                               'label'     : "Periode",
            //                                               'icon'      : "assets/icons/invoice.png",
            //                                               'route'     : './sales/period'
            //                                         },
            //                                         {
            //                                               'id'        : 'master-data-team',  
            //                                               'label'     : "Termes",
            //                                               'icon'      : "assets/icons/invoice.png",
            //                                               'route'     : './sales/term'
            //                                         },

            //                                         {
            //                                           'id'        : 'master-data-team',  
            //                                           'label'     : "Menus Assabil",
            //                                           'icon'      : "assets/icons/invoice.png",
            //                                           'route'     : './sales/assabil-menu'
            //                                         },

            //                                         {
            //                                               'id'        : 'master-data-team',  
            //                                               'label'     : "Formulaires",
            //                                               'icon'      : "assets/icons/invoice.png",
            //                                               'route'     : './sales/form'
            //                                         }
            //                                       ]
            //                       }
            //                     ]
            //     };

 
}
